<!-- eslint-disable -->
<template>
    <div class="form-container">
        <div class="box" v-if="user.isEducationMaterialsAvailable">
            <presentations
              slug="EducationMaterials"
              :page="$route.query.page"
              :is-education-materials="true"
            ></presentations>
        </div>
        <box v-else>
            <div>
                {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
            </div>
        </box>
    </div>
</template>

<script>
    /*eslint-disable*/
    import Presentations from '../games/games-forms/PresentationsForm.vue'

    import BillingBlockMixin from '../../utils/user/BillingBlockMixin';

    export default {
        mixins: [BillingBlockMixin],
        components: {
            Presentations,
        },
    }
</script>

<style lang="scss" scoped>
    .players-container {
        justify-content: center;
        overflow: hidden;
        margin-right: 0;
        margin-left: 0;
    }
    .player-block {
        z-index: 1;
        background-color: $x-color-white;
        margin: $space-x-small;
        @include media($sm) {
            @include inline-space($space-small);
            margin: 0 0 -$space-x-small;
        }
    }
    .cs-button {
        border: 1px solid $color-grey-500;
        &:active {
            border: 1px solid $color-grey-500;
        }
        &--active {
            color: $color-green-600;
            background-color: $x-color-white;
            @include media($sm) {
                border-bottom: 1px solid transparent;
            }
            &:hover {
                background-color: $x-color-white;
            }
            &:focus {
                background-color: $x-color-white;
            }
        }
    }
    .player-block-divider {
        width: 100%;
        border-bottom: 1px solid $color-grey-500;
        margin-top: $space-small;
        @include media($sm) {
            margin-top: unset;
        }
    }
</style>
